/*
 * Copyright (c) 2025. Bolmate B.V.
 */
import './style/iconWithLabel.scss';

import {AwesomeIcon} from '@dvrd/dvr-controls';
import {IconName, IconPrefix} from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import classNames from 'classnames';

interface Props extends React.ComponentProps<any> {
    label: string;
    name: IconName;
    labelClassName?: string;
    iconClassName?: string;
    prefix?: IconPrefix;
}

export default function IconWithLabel(props: Props) {
    const {label, labelClassName, className, iconClassName} = props;
    return <div className={classNames('icon-with-label', className)}>
        <AwesomeIcon {...props} className={iconClassName}/>
        <label className={classNames('icon-title', labelClassName)}>{label}</label>
    </div>
}